module.exports = __webpack_public_path__ + "img/medio1.a6c997c4.jpg";